module.exports = __webpack_public_path__ + "img/mobile_menu_open.svg";